module.exports = __webpack_public_path__ + "img/eye-evil.e7514f04.svg";